function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectDestructuringEmpty(o) {
    if (o === null || o === void 0) throw new TypeError("Cannot destructure " + o);
    return o;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { Dialog } from "@headlessui/react";
import { Link as LinkComponent } from "@labs/schema";
import clsx from "clsx";
import { AnimatePresence, motion } from "framer-motion";
import { debounce } from "lodash";
import React, { forwardRef, useEffect, useState } from "react";
var radialExpand = {
    open: function(param) {
        var width = param.width, height = param.height;
        var center = "".concat(width, "px 0px");
        return {
            clipPath: "circle(".concat(Math.max(width, height) * 1.4, "px at ").concat(center, ")"),
            transition: {
                type: "spring",
                stiffness: 130,
                damping: 40
            }
        };
    },
    closed: function(param) {
        var width = param.width;
        var center = "".concat(width, "px 0px");
        return {
            clipPath: "circle(30px at ".concat(center, ")"),
            transition: {
                type: "spring",
                stiffness: 400,
                damping: 40
            }
        };
    }
};
var Path = function(props) {
    return /*#__PURE__*/ React.createElement(motion.path, _extends({
        fill: "transparent",
        strokeWidth: "2",
        stroke: "currentColor",
        strokeLinecap: "round"
    }, props));
};
export var MenuToggle = /*#__PURE__*/ forwardRef(function MenuToggle(param, ref) {
    var toggle = param.toggle, menuToggle = param.menuToggle;
    return /*#__PURE__*/ React.createElement("button", {
        ref: ref,
        onClick: toggle,
        "aria-expanded": menuToggle,
        "aria-haspopup": "true",
        "aria-controls": "main-nav",
        className: clsx("z-40 fixed top-[38px] lg:top-[80px] right-0 focus bg-turquoise-500 hover:bg-black p-3 md:p-5 flex items-center justify-center text-white hover:text-white", {
            "bg-black focus-visible:outline-white": menuToggle
        })
    }, /*#__PURE__*/ React.createElement("span", {
        className: "sr-only"
    }, "Toggle menu"), /*#__PURE__*/ React.createElement("svg", {
        width: "30",
        height: "30",
        viewBox: "0 0 30 30"
    }, /*#__PURE__*/ React.createElement(Path, {
        variants: {
            closed: {
                d: "M2 4L28 4"
            },
            open: {
                d: "M2 2L28 28"
            }
        }
    }), /*#__PURE__*/ React.createElement(Path, {
        variants: {
            closed: {
                d: "M2 15L20 15"
            },
            open: {
                d: "M-2 15L-2 15"
            }
        }
    }), /*#__PURE__*/ React.createElement(Path, {
        variants: {
            closed: {
                d: "M2 26L12 26"
            },
            open: {
                d: "M28 2L2 28"
            }
        }
    })));
});
export function Overlay(param) {
    var children = param.children;
    var _useState = _slicedToArray(useState(false), 2), isOpen = _useState[0], setIsOpen = _useState[1];
    var _React_useState = _slicedToArray(React.useState({
        width: 1440,
        height: 960
    }), 2), dimensions = _React_useState[0], setDimensions = _React_useState[1];
    useEffect(function() {
        var resizeHandler = function() {
            setDimensions({
                width: window.innerWidth,
                height: window.innerHeight
            });
        };
        resizeHandler();
        window.addEventListener("resize", debounce(resizeHandler, 1000));
        return function() {
            return window.removeEventListener("resize", resizeHandler);
        };
    }, []);
    var AutoCloseLink = function(_param) {
        var props = _extends({}, _objectDestructuringEmpty(_param));
        return /*#__PURE__*/ React.createElement(LinkComponent, _extends({}, props, {
            onClick: function() {
                setIsOpen(false);
            }
        }));
    };
    var close = function() {
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ React.createElement(motion.div, {
        animate: isOpen ? "open" : "closed"
    }, /*#__PURE__*/ React.createElement(MenuToggle, {
        toggle: function() {
            return setIsOpen(!isOpen);
        },
        menuToggle: isOpen
    }), /*#__PURE__*/ React.createElement(AnimatePresence, null, isOpen ? /*#__PURE__*/ React.createElement(Dialog, {
        open: isOpen,
        onClose: close,
        static: true
    }, /*#__PURE__*/ React.createElement(motion.div, {
        initial: "closed",
        animate: "open",
        exit: "closed"
    }, /*#__PURE__*/ React.createElement(MenuToggle, {
        toggle: function() {
            return setIsOpen(!isOpen);
        },
        menuToggle: isOpen
    })), /*#__PURE__*/ React.createElement(motion.div, {
        id: "main-nav",
        initial: "closed",
        animate: "open",
        exit: "closed",
        className: "fixed bg-turquoise-500 z-10 inset-0 overflow-y-auto",
        custom: dimensions,
        variants: radialExpand
    }, children({
        Link: AutoCloseLink
    }))) : null));
}
